import { ColorsInterface } from '@r1-frontend/ui-kit/themes/colors/types';

const light: ColorsInterface = {
    brand: '#ff312c',
    notifications: {
        success: '#15A250',
        warning: '#E7910E',
        error: '#DD4333',
        info: '#9BCDDD',
    },
    links: {
        accent: '#518399',
        native: '#626c77',
    },
    text: {
        head: '#181b21',
        primary: '#393c41',
        hint: '#9498a1',
        disabled: '#9db6c2',
        contrast: '#ffffff',
        info: '#5c5e62',
    },
    system: {
        accent: '#ff312c',
        primary: '#1e1f33',
        secondary: '#aad5ea',
        disabled: '#d4e5ec',
        deep: '#e6eef5',
        light: '#f5f8fB',
        background: '#ffffff',
    },
    overlay: '#20202099',
};

export default light;
